import { ReactElement } from 'react'
import { useRouter } from 'next/router'
import { Box } from '@chakra-ui/react'
import { MultiBrandPicker } from '@modules/app'
import { useComposable } from '@modules/oriuminc/base'
import { CartHeader } from '../Headers/CartHeader'

interface LayoutProps {
  children: ReactElement | ReactElement[]
}

export const Layout = ({ children }: LayoutProps) => {
  const router = useRouter()
  const { path } = useComposable()
  const isCheckout = router?.pathname === path.getCheckout()

  if (isCheckout) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        bg={'#FAFAFA'}
      >
        <Box flexGrow={1}>{children}</Box>
      </Box>
    )
  }

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <MultiBrandPicker />
      <CartHeader />
      <Box flexGrow={1}>{children}</Box>
      <span id="zendesk-live-chat" />
    </Box>
  )
}
